import { Pipe, PipeTransform } from '@angular/core';
import { MtnaPopoverConfig } from '@mtna/core-angular';
import { Option } from '@rds/rds-packaging-ts';

/**
 * Creates a MtnaPopoverConfig for a given packaging Option
 * in order to display the option's description.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsOptionPopoverConfig',
})
export class RdsOptionPopoverConfigPipe implements PipeTransform {
  /**
   * Creates a MtnaPopoverConfig for a given packaging Option
   * in order to display the option's description.
   *
   * @param value packaging `Option`
   * @returns popover config describing the packaging option
   */
  transform(value: Option): MtnaPopoverConfig | null {
    return !value.name || !value.description ? null : new MtnaPopoverConfig(value.name, value.description);
  }
}
